export type HmdaMultiSelectValue = Record<string, boolean>

export function parseHmdaMultiSelect(value: string | null | undefined): HmdaMultiSelectValue {
  if (!value || !String(value).trim()) return {}

  try {
    const parsed = JSON.parse(String(value).trim())
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return {}

    return Object.fromEntries(
      Object.entries(parsed)
        .filter(([, selected]) => selected === true)
        .map(([key]) => [key, true]),
    )
  } catch {
    return {}
  }
}

export function serializeHmdaMultiSelect(
  value: HmdaMultiSelectValue | string[] | null | undefined,
): string {
  if (value === null || value === undefined) return ''

  if (Array.isArray(value)) {
    const selected = value.filter(Boolean)
    if (!selected.length) return ''
    return JSON.stringify(Object.fromEntries(selected.map((key) => [key, true])))
  }

  const selected = Object.entries(value)
    .filter(([, selected]) => selected === true)
    .map(([key]) => key)
  if (!selected.length) return ''
  return JSON.stringify(Object.fromEntries(selected.map((key) => [key, true])))
}

export function isHmdaMultiSelectSelected(value: string | null | undefined, option: string): boolean {
  return !!parseHmdaMultiSelect(value)[option]
}

export function getHmdaMultiSelectSelected(value: string | null | undefined): string[] {
  return Object.keys(parseHmdaMultiSelect(value))
}

export function formatHmdaMultiSelectDisplay(value: string | null | undefined): string {
  return getHmdaMultiSelectSelected(value).join(', ')
}

export function toHmdaMultiSelectInputValue(value: string | null | undefined): HmdaMultiSelectValue {
  return parseHmdaMultiSelect(value)
}

export const HMDA_MULTI_SELECT_FIELDS = ['ethnicity', 'hispanicDetail', 'race', 'asianDetail', 'pacificIslanderDetail'] as const

export function isHmdaMultiSelectField(key: string): boolean {
  return (HMDA_MULTI_SELECT_FIELDS as readonly string[]).includes(key)
}
